import { render, staticRenderFns } from "./EditCodeContractStructure.vue?vue&type=template&id=0b6cd500"
import script from "./EditCodeContractStructure.vue?vue&type=script&lang=js"
export * from "./EditCodeContractStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports